var cpc_currentPrice = 0;
var miniMumCartValue = 0;
var priceMarkerDecimals = 0;
var baseVariantId = 0;
var cpc_newVariantId = 0;
var cpc_calculatorId = '';
var cpc_waitforcartconfirmation = true
var baseCalculatorApiUrl = 'https://calcapi.printgrid.io'
var calculatorStyling = null
var cpc_data = {};
var cpc_configData={};
var spaceRegex = new RegExp(" ", "g");
var specialCharactersRegex = /[^\w\s]/gi;
var cpc_shopUrl = "apippa";
var cpc_product_default_price = 0.00
var cpc_pageLoaded = false;
var cpc_isPreview = false;
var cpc_productId = 0;
var cpc_metaFields = [];

jQuery(document).ready(function () {
        if(typeof String.prototype.replaceAll === "undefined") {
    String.prototype.replaceAll = function(match, replace) {
       return this.replace(new RegExp(match, 'g'), () => replace);
    }
  }
    if (cpc_pageLoaded === false) {
        cpc_pageLoaded = true;
        console.log('calculator loading');
        if (typeof Shopify !== 'undefined') {
            cpc_shopUrl = Shopify.shop;
            if (window.meta.product !== undefined) {
                cpc_productId = window.meta.product.id;
            }
        } else {
            var getUrl = $('#calculator_preview_storeurl').val()
            cpc_shopUrl = getUrl
            cpc_isPreview = true
        }

        //Only load calculator if its not loaded already
        var idUpdated = document.querySelector('select[name="oldId"]');
        if (idUpdated == null)
            DetectPage();
    }
});

//This method detects the page and runs the required script
function DetectPage() {
    const path = window.location.pathname;
    const potentialHandle = path.substring(path.lastIndexOf("/") + 1);
    switch (potentialHandle.toUpperCase()) {
        case 'CART': ProcessCartPage(); break

        default: ProcessProductPage(); break;
    }
}

//Process Product Page

//Process Cart Page

//Checkout Helpers

//Build components

//Price Calculation

//Everything Else

//Common Utils


async function LoadCalculator(calculatorId) {
    n = new Request(baseCalculatorApiUrl + "/api/calculator/load?id=" + calculatorId + "&productId=" + cpc_productId, { method: "GET" });
    return await fetch(n)
}

async function ProcessProductPage() {

var submitButton;
var productForm;
var calculatorId;
    jQuery('form[action*="/cart/add"]').each(function (i, e) {
        var isCpcFormOverride = jQuery(e).data("cpc-product-form");

        if (e.querySelector('[type="submit"]') && (submitButton === undefined || (isCpcFormOverride !== undefined && isCpcFormOverride == true))) {
            submitButton = null !== e ? e.querySelector('[type="submit"]') : null
            productForm = e;
        }
        if (e.querySelector('button[class*="cart"]') && (submitButton === undefined || (isCpcFormOverride !== undefined && isCpcFormOverride == true))) {
            submitButton = null !== e ? e.querySelector('button[class*="cart"]') : null
            productForm = e;
        }
    });

    this.productForm=productForm;
    this.submitButton= submitButton;

    var calcProduct = await fetchCalculatorByProduct();
    if(calcProduct!=null && calcProduct.CalcUniqueIden !=null && calcProduct.CalcUniqueIden !=undefined)
    {
      console.log("CalculatorId found from API");
      calculatorId = calcProduct.CalcUniqueIden;
      console.log(calculatorId);
    }
    else
    {
      this.calculatorElement = document.getElementById('calculator-block')
      var customCalculatorDiv = document.getElementById('custom-calculator')
      calculatorId = jQuery(customCalculatorDiv).data('calculatorid')
      console.log("CalculatorId found from Fallback Method");
    }

    if ( calculatorId.length === 0 ) {
      this.calculatorElement = document.getElementById('calculator-block')
      var customCalculatorDiv = document.getElementById('custom-calculator')
      calculatorId = jQuery(customCalculatorDiv).data('calculatorid')
      console.log("CalculatorId found from Fallback Method");
      console.log(calculatorId);
    }

    if (calculatorId != null && calculatorId != undefined) {
        cpc_calculatorId = calculatorId;
        console.log('calculator found', calculatorId);
        console.log('product Id', cpc_productId);
        console.log('submit', this.submitButton)

        loadScripts();
        await fetchProductMetaData();

        var priceElements = ['product-price', 'product-single__price', 'selector-wrapper', 'current_price',
            'product__price', 'shopify-payment-button', 'single-option-selector'];
        priceElements.forEach(elem => {
            var elementToHide = jQuery('.' + elem);
            elementToHide.addClass("hide-element");
        })

        //Change the old element so that you can create new element with same id
        var variantSelector = document.querySelector('select[name="id"]');
        if (variantSelector !== null) {
            baseVariantId = variantSelector.value;
            variantSelector.setAttribute('name', 'oldId');
        }

        var variantSelector = document.querySelector('input[name="id"]');
        if (variantSelector !== null) {
            baseVariantId = variantSelector.value;
            variantSelector.setAttribute('name', 'oldId');
        }

        this.productForm.addEventListener("submit", function (t) {
            t.preventDefault();
            t.stopImmediatePropagation();
            t.stopPropagation();
        });

        //Load css
        var fileref = document.createElement("link")
        fileref.setAttribute("rel", "stylesheet")
        fileref.setAttribute("type", "text/css")
        //fileref.setAttribute("href", baseCalculatorApiUrl + '/shopify/style.css')
        fileref.setAttribute("href", baseCalculatorApiUrl + '/style?shop=' + cpc_shopUrl)
        document.getElementsByTagName("head")[0].appendChild(fileref)

        //Remove all listeners
        var el = this.submitButton;
        elClone = el.cloneNode(true);
        el.parentNode.replaceChild(elClone, el);
        this.submitButton = elClone;

        this.submitButton.addEventListener("click", await HandleAddToCartEvent);
        // this.submitButton.addEventListener("touchstart", await HandleAddToCartEvent);

        //To hide the loader once page has loaded
        var customCalcBlock = jQuery('#custom-calculator');
        customCalcBlock.hide();

        var calculatorData = LoadCalculator(calculatorId);
        calculatorData.then(response => response.json())
            .then(json => {
                cpc_data = json.CalculatorData
                cpc_metaFields = json.MetaFields;
                cpc_configData= json.Configuration;
                calculatorStyling = json.Styling;
                cpc_waitforcartconfirmation = json.WaitForCartConfirmation;

                console.log('meta-fields', cpc_metaFields);

                var builtData = buildCalculator(cpc_data);

                var elem = document.querySelector(".add-to-cart");//jQuery(".add-to-cart");
                if (elem == null) {
                    elem = document.querySelector("form[action='/cart/add'] button[type=submit]");
                }
                if (elem == null) {
                    elem = this.submitButton;
                }
                elem = this.submitButton;
                console.log('render-block', elem);

                var borderClass = calculatorStyling.Border === 'rounded' ? "class='rounded-edges'" : "";
                jQuery(elem).parent().prepend("<div id='calculator' data-calcid='" + calculatorId + "' " + borderClass + " style='background-color:" + calculatorStyling.UpperBackground + "'>" + builtData + "</div>");

                //Custom Store JS
                var shopCustomJsPath =baseCalculatorApiUrl + '/api/customscripts/getCustomScript?shop=' + cpc_shopUrl; 
                if(shopCustomJsPath!=null && shopCustomJsPath.length>0)
                {
                var customStoreJSRef = document.createElement("script");
                customStoreJSRef.setAttribute("type", "text/javascript");
                customStoreJSRef.setAttribute("src", shopCustomJsPath);
                customStoreJSRef.defer=true;
                customStoreJSRef.setAttribute("crossorigin",'anonymous');
                document.getElementsByTagName("head")[0].appendChild(customStoreJSRef);
                }

                firstLoad();
                PreventCheckoutOnEnter();
            });

    }
}

async function fetchCalculatorByProduct()
{
   try {
     let cpcCalcualtor;
      await fetch(baseCalculatorApiUrl + "/api/calculator/getCalculatorByProductId?id=" + cpc_productId)
                .then(response => response.json())
                .then(async function (cpc_calcProduct) {
                    if (cpc_calcProduct !== undefined) {
                       cpcCalcualtor = cpc_calcProduct;
                    }
                });
            return cpcCalcualtor;
        }
    catch (e)
    {
        var errMsg = "CPC Error:. ProductId =" + cpc_productId;
        globalHelper_ReportError(e, errMsg);
    }
}

async function HandleAddToCartEvent(t)
    {
        t.preventDefault()
        t.stopImmediatePropagation();
        t.stopPropagation();

        var props = GetVariantProperties();

        //Create Variant
        jQuery.ajax({
            method: "POST",
            url: baseCalculatorApiUrl + "/api/calculator/variant",
            data: JSON.stringify({ calculatorId: cpc_calculatorId, productId: window.meta.product.id, properties: { ...props } }),
            headers: { Accept: "application/json", "Content-Type": "application/json" }
        })
            .done(function (variantId) {
                var quantity = 1;
                var quantSelector = jQuery("#Quantity");
                if (quantSelector) {
                    var n = t.value;
                    if (n) { quantity = Number(n); }
                }

                if (typeof variantId === 'object' && variantId !== null) {
                    showDialog();
                    return;
                }

                var validationError = ValidateInputs();
                if (validationError === false) {
                    var variantInput = document.getElementById('variantIdCustom');
                    variantInput.value = variantId
                    UpdateAllSelectedCheckBox();
                    UpdateAllHiddenElements();
                    SubmitFormData();
                }
                return;
            });
    }

async function fetchProductMetaData() {
    try {
        if (cpc_isPreview === false) {
            let cpc_product_page_url = window.location.href.split('?')[0]
            let previewKey = window.location.href.split('?')[1] ?? ''
            let hasPreviewKey = previewKey.startsWith("preview_key");
            var productFetchUrl = cpc_product_page_url + ".js?d=" + Math.random();
            if (hasPreviewKey === true)
                productFetchUrl = cpc_product_page_url + ".js?" + previewKey + "&d=" + Math.random();

            await fetch(productFetchUrl)
                .then(response => response.json())
                .then(async function (cpc_product_meta_data) {
                    if (cpc_product_meta_data !== undefined) {
                        var default_variant = cpc_product_meta_data.variants[0]
                        if (default_variant !== undefined) {
                            cpc_product_default_price = (default_variant.price / 100)
                        }
                    }
                });
            console.log('shopify product price', cpc_product_default_price);
        } else {
            console.log('Calculator in preview mode')
            cpc_product_default_price = 10;
        }
    }
    catch (e)
    {
        var errMsg = "Shopify Price Error:. ProductId =" + cpc_productId;
        globalHelper_ReportError(e, errMsg);
        cpc_product_default_price = 0;

        setTimeout(function () {
            window.location.reload();
        }, 3000);
    }
}


function ProcessCartPage() {

    CARTPAGE_adjustLineItems();
}

function CARTPAGE_adjustLineItems() {
    jQuery('input[class*="qty"]').on('change', function () {
        setTimeout(() => {
            console.log('quantity changed');
            CARTPAGE_adjustLineItems();
        }, 1000);
    });

    //Remove the cart unique_id
    var all = document.querySelectorAll("li,p,span,label");
    var regexPattern = /[a-zA-Z0-9: ]?cpc_[a-zA-Z0-9]+/gi
    for (var i = 0, max = all.length; i < max; i++) {
        //let elem = all[i];
        //if (regexPattern.test(elem.textContent)) {
        //    $(elem).html('');
        //}
    }

    fetch("/cart.js?cache=false&q=" + Math.random())
        .then(response => response.json())
        .then(async function (cartData) {
            let cart_items = cartData.items;
            let cart_total_price = cartData.total_price;
            let cart_original_total_price = cartData.original_total_price;
            let missingPriceVariants = [];
            for (let i = 0; i < cart_items.length; i++) {
                if (cart_items[i].price === 0)
                    missingPriceVariants.push(cart_items[i]);
            }
            var cpc_variantData = await CARTPAGE_LoadVariants(missingPriceVariants);

            if (cpc_variantData.length > 0) {
                for (let i = 0; i < cpc_variantData.length; i++) {
                    let currentVariant = cpc_variantData[i];
                    let cpc_quantity = 0;
                    jQuery.each(missingPriceVariants, function (i, missingVariant) {
                        if (missingVariant.variant_id == currentVariant.ShopifyVariantId)
                            cpc_quantity = missingVariant.quantity
                    });

                    cart_total_price += currentVariant.Amount * cpc_quantity * 100;

                    jQuery("cpc.product_title[data-id='" + currentVariant.ShopifyVariantId + "']").html(currentVariant.ShopifyProductTitle);
                    jQuery("cpc.original_price[data-id='" + currentVariant.ShopifyVariantId + "']").html(CARTPAGE_formatPrice(cartData.currency, currentVariant.Amount));
                    jQuery("cpc.price[data-id='" + currentVariant.ShopifyVariantId + "']").html(CARTPAGE_formatPrice(cartData.currency, currentVariant.Amount));
                    jQuery("cpc.discounted_price[data-id='" + currentVariant.ShopifyVariantId + "']").html(CARTPAGE_formatPrice(cartData.currency, currentVariant.Amount));

                    jQuery("cpc.final_line_price[data-id='" + currentVariant.ShopifyVariantId + "']").html(CARTPAGE_formatPrice(cartData.currency, currentVariant.Amount * cpc_quantity));
                    jQuery("cpc.line_price[data-id='" + currentVariant.ShopifyVariantId + "']").html(CARTPAGE_formatPrice(cartData.currency, currentVariant.Amount * cpc_quantity));
                    jQuery("cpc.original_line_price[data-id='" + currentVariant.ShopifyVariantId + "']").html(CARTPAGE_formatPrice(cartData.currency, currentVariant.Amount * cpc_quantity));

                    var itemImage = jQuery("img[data-cpcimageid='" + currentVariant.ShopifyVariantId + "']");
                    if (itemImage !== undefined && currentVariant.ProductImageUrl !== null && itemImage.length > 0) {
                        itemImage[0].setAttribute('src', currentVariant.ProductImageUrl);
                        itemImage[0].setAttribute('data-src', currentVariant.ProductImageUrl);
                    }
                }

                jQuery("cpc.final_price").html(CARTPAGE_formatPrice(cartData.currency, (cart_total_price / 100), true));
                jQuery("cpc.cart_total_price").html(CARTPAGE_formatPrice(cartData.currency, (cart_total_price / 100), true));

            }
        });
}

function CARTPAGE_formatPrice(currencyCode, amount, isTotalField) {
    let amountFormated = Number(amount).toFixed(2);
    let cpc_CurrencySymbol = CARTPAGE_getCurrency(currencyCode, isTotalField);
    
    let moneyFormat = getCurrencyFormat(currencyCode);
    let formattedAmount = formatMoney(amount, moneyFormat.money_format);
    console.log(formattedAmount);
    //return formattedAmount;
    return cpc_CurrencySymbol.before + amountFormated + ' ' + cpc_CurrencySymbol.after
}

function CARTPAGE_getCurrency(currencyCode, isTotalField = false) {
    var currencyCodeUpperCase = currencyCode.toUpperCase()
    switch (currencyCodeUpperCase) {
        case 'USD': return { before: '$', after: isTotalField ? currencyCodeUpperCase : '' }; break;
        case 'CAD': return { before: '$', after: isTotalField ? currencyCodeUpperCase : 'CAD' }; break;
        case 'DKK': return { before: '', after: isTotalField ? currencyCodeUpperCase : 'KR' }; break;
        case 'GBP': return { before: '&pound;', after: isTotalField ? currencyCodeUpperCase : '' }; break;
        case 'AUD': return { before: '$', after: isTotalField ? currencyCodeUpperCase : 'AUD' }; break;
        case 'BRL': return { before: 'R$', after: isTotalField ? currencyCodeUpperCase : '' }; break;
        case 'ZAR': return { before: 'R', after: isTotalField ? currencyCodeUpperCase : '' }; break;
        case 'SGD': return { before: '$', after: isTotalField ? currencyCodeUpperCase : '' }; break;
        case 'SGD': return { before: '$', after: isTotalField ? currencyCodeUpperCase : '' }; break;
        case 'EUR': return { before: '&euro;', after: isTotalField ? currencyCodeUpperCase : '' }; break;
        case 'MAD': return { before: '', after: isTotalField ? 'dh' : 'dh' }; break;
        case 'OMR': return { before: '', after: isTotalField ? currencyCodeUpperCase : currencyCodeUpperCase }; break;
        case 'TRY': return { before: '', after: isTotalField ? currencyCodeUpperCase : '&#8378;' }; break;
        case 'CLP': return { before: '$', after: '' }; break;
        case 'IDR': return { before: 'RP', after: '' }; break;
        case 'TRY': return { before: '', after: 'TL' }; break;
        case 'MXN': return { before: '$', after: '' }; break;
        default: return { before: '', after: currencyCode.toUpperCase() }; break;
    }
}

async function CARTPAGE_LoadVariants(variants) {
    //Create Variant
    let cpc_variantData = null;
    n = new Request(baseCalculatorApiUrl + "/api/calculator/loadVariants", { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify({ shop: cpc_shopUrl, variants: variants }) });
    await fetch(n).then(response => response.json())
        .then(async (variants) => {
            cpc_variantData = variants;
        })

    return cpc_variantData;
}


﻿function SubmitFormData() {
    jQuery('.loading-anim').show();
    console.log('posting product data...')
   var formm=this.productForm;

    let quantity=1;
    //console.log('before delete');
        console.log(formm);
        [...formm.elements].forEach((e)=> {
          if(jQuery(e).data("cpc_isquantity")===true)
          { 
            let name =jQuery(e).attr("name");
            quantity= formm.elements[name].value;
            jQuery(e).remove();
          }
        });

        //console.log('after delete');
        //console.log(formm);

    // var dataString = jQuery(formm).serialize();
    var formData = new FormData(formm);
    formData.append("quantity",quantity);
    jQuery.ajax({
        type: "POST",
        url: "/cart/add",
        data: formData,
        xhr: function () {
            var xhr = new window.XMLHttpRequest();
            if (calculatorStyling !== null && calculatorStyling.FileUploadProgressText !== null && calculatorStyling.FileUploadProgressText !== '') {

                let cpc_file_upload_count = 1;
                xhr.upload.addEventListener("progress", function (evt) {
                    cpc_file_upload_count++;
                    if (evt.lengthComputable && cpc_file_upload_count > 2) {
                        var percentComplete = (evt.loaded / evt.total) * 100;
                        console.log('percentComplete', percentComplete);
                        percentComplete = percentComplete.toFixed(2);
                        jQuery('#cpc_loader_text').html(calculatorStyling.FileUploadProgressText + ' ' + percentComplete + ' %');
                    }
                }, false);
            }
            return xhr;
        },
        //timeout: 1200000,
        processData: false,
        contentType: false,
        success: function () {
            if(calculatorStyling !== null && calculatorStyling.LoaderText !== '')
                jQuery('#cpc_loader_text').html(calculatorStyling.LoaderText);
            IsShopifyCartReady();
        },
        error: function (err) {
            console.log('add to cart request errored', err);

            if (calculatorStyling !== null && calculatorStyling.LoaderText !== '')
                jQuery('#cpc_loader_text').html(calculatorStyling.LoaderText);
            IsShopifyCartReady();
        }
    });
}

function IsShopifyCartReady(count = 0) {
    var ajaxCartClasses = []; //['cart-link__bubble--visible', 'cart-link'];
    var ajaxFound = false;
    var ajaxCartClass = null;
    ajaxCartClasses.forEach(cartElem => {
        if (ajaxFound === false && jQuery('.' + cartElem)[0]) {
            ajaxCartClass = cartElem;
            ajaxFound = true;
        }
    })

    if (cpc_waitforcartconfirmation === false) {
        if (ajaxFound === true) {
            jQuery('.' + ajaxCartClass).trigger('click');
            jQuery('.loading-anim').hide();
        } else {
            window.location.replace("/cart");
        }
    }
    else {
        fetch("/cart.js?cache=false&q=" + Math.random())
            .then(response => response.json())
            .then(function (response) {
                var cartDataAsString = JSON.stringify(response)
                var zeroPriceIndex = cartDataAsString.search("price\":0")
                if (zeroPriceIndex === -1) {
                    if (ajaxFound === true) {
                        jQuery('.' + ajaxCartClass).trigger('click');
                        jQuery('.loading-anim').hide();
                    } else {
                        window.location.replace("/cart");
                    }

                    if (ajaxFound === false) {
                        window.location.replace("/cart");
                    }
                } else {
                    count++;
                    setTimeout(() => {
                        console.log('waiting for cart confirmation');
                        IsShopifyCartReady(count);
                    }, 1000);
                }
            })
            .catch(function (error) {
                console.log(error);
                return false;
            });
    }
}

function GetVariantProperties() {
    var props = [];
    var lookupProperties = {};
    jQuery(".calc-prop").each(function (index, element) {
        let isHidden = jQuery(element).is(':hidden');
        let isLookupElement = jQuery(element).data('lookup') !== undefined;
        let IsLookupFormulaElement = isLookupElement ? jQuery(element).data('isformula') === true : false;

          var elementType = jQuery(element).prop('type');
            if(elementType == 'number')
            {
                var result= CheckNumberInputValidity(element);
                if(result!==undefined && !result)
                {
                   isError = true;
                jQuery(element).addClass('error-border');
                return;
                }
            }

        if (isHidden === false || IsLookupFormulaElement === true) {
            var name = jQuery(element).attr('name')
            var value = jQuery(element).val()

            let isCheckBox = jQuery(element).is(":checkbox");
            var elementType = jQuery(element).prop('nodeName');
            if (jQuery(element).is(":radio") === true) {
                let isChecked = jQuery(element).is(":checked")
                if (isChecked === false)
                    return true;
                value = jQuery(element).data("val")
            }
            else if (elementType === "LABEL") {
                value = jQuery(element).data("val")
            }
            else if (isCheckBox === true) {
                let isChecked = jQuery(element).is(":checked")
                let checkedValue = jQuery(element).data("checkedvalue")
                let uncheckedValue = jQuery(element).data("uncheckedvalue")
                value = isChecked ? checkedValue : uncheckedValue;
            }

            name = name.replace("properties[", "");
            name = name.replace("]", "");
            if (name === 'length') {
                name = 'Length'
            }

            //For lookup element prepare the data
            if (isLookupElement === true) {
                let lookupelementindex = jQuery(element).data("lookupelementindex")
                let elementIdentifier = jQuery(element).data("identifier");
                if (typeof lookupProperties[elementIdentifier] === 'undefined') {
                    var lookupElementProcessedElement = {
                        elementName: elementIdentifier,
                        input1: 0,
                        input2: 0
                    };

                    if (lookupelementindex === 1)
                        lookupElementProcessedElement.input1 = parseFloat(jQuery(element).val());
                    else if (lookupelementindex === 2)
                        lookupElementProcessedElement.input2 = parseFloat(jQuery(element).val());

                    lookupProperties[elementIdentifier] = lookupElementProcessedElement;
                }
                else {
                    let lookupElementProcessedElement = lookupProperties[elementIdentifier];
                    if (lookupelementindex === 1)
                        lookupElementProcessedElement.input1 = parseFloat(jQuery(element).val());
                    else if (lookupelementindex === 2)
                        lookupElementProcessedElement.input2 = parseFloat(jQuery(element).val());
                }
            }
            else {
                props[name] = value;
            }
        }
    });

    //Now process lookup element
    for (var key in lookupProperties) {
        props[key] = lookupProperties[key];
    }

    props['shopify_product_price'] = cpc_product_default_price;

    //apply meta fields
    cpc_metaFields.forEach(item => {
        props['shopify_meta_' + item.key] = item.value;
    });

    return props;
}


﻿
function buildCalculator(inpData) {
    var div = "";
    inpData.Elements.forEach(function (element, index) {
        switch (element.ElementType) {
            case 'TextInput':
            case 'NumberInputNew': var txtInp = buildNumberInput(element);
                div += txtInp;
                break;
            case 'SelectList': var txtDdl = buildDropDown(element);
                div += txtDdl;
                break;
            case 'ImageSelector': var txtDdl = buildImageSelector(element);
                div += txtDdl;
                break;
            case 'TextEditor': var txtInp = buildTextDisplayBlock(element);
                div += txtInp;
                break;
            case 'ImageUpload': var imgInp = buildImageElement(element);
                div += imgInp
                break;
            case 'LongTextInput': var textInp = buildTextInput(element);
                div += textInp
                break;
            case 'Checkbox': var textInp = buildCheckboxInput(element);
                div += textInp
                break;
            case 'Calculation': var txtInp = buildCalculationElement(element);
                div += txtInp;
                break;
            case 'Lookup': var txtInp = buildLookupInput(element);
                div += txtInp;
                break;
            case 'PriceMarker': var txtInp = buildPriceMarker(element);
                div += txtInp;
                break;
        }
    });

    div += buildVariantElement();

    return div;
}

function buildNumberInput(element) {
    var minValue = element.MinValue != undefined ? element.MinValue : 0;
    var maxValue = element.Maxvalue != undefined ? element.Maxvalue : 100000;
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let isQuantity= element.isQuantity != undefined ? element.isQuantity : false;
    var step = element.Maxdecimals != undefined ? generateStep(element.Maxdecimals) : 1;
    var conditionalDisplay = getConditionalDisplay(element)
    var parsedName = element.Name.replace(/"/g, '&quot;');
    let toolTipHtml= enableToolTip===true? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></span>"
                : "";
    return "<div class='element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+ "</label><input onkeyup='PriceUpdation(this);' onchange='PriceUpdation(this);' data-identifier='" + element.Identifier + "' class='calc-prop numInput-cpc' step='" + step + "' min='" + minValue + "' max='" + maxValue + "' onblur='CheckNumberInputValidity(this);' data-rangeenabled='" + element.value_range_enabled + "' data-calcname='" + element.Name + "' name=\"properties[" + parsedName + "]\" data-cpc_isquantity='"+isQuantity+"' value='" + element.DefaultValue + "' type='number'/></div>";
    // return "<div class='element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + "<span class='c_tooltip'><i class='fas fa-info-circle'></i><span class='c_tooltiptext'>"+element.toolTip+"</span></span></label><input onfocusout='onChange(null)' data-identifier='" + element.Identifier + "' class='calc-prop' step='" + step + "' min='" + minValue + "' max='" + maxValue + "' onblur='validity.valid || (value = \"\");' data-rangeenabled='" + element.value_range_enabled + "' data-calcname='" + element.Name + "' name=\"properties[" + parsedName + "]\" value='" + element.DefaultValue + "' type='number'/></div>";
    
}

function buildLookupInput(element) {
    var input1_minvalue = element.input1_minvalue != undefined ? element.input1_minvalue : 0;
    var input1_maxvalue = element.input1_maxvalue != undefined ? element.input1_maxvalue : 100000;
    var input1_step = element.input1_maxdecimals != undefined ? generateStep(element.input1_maxdecimals) : 1;
    var input1_isFormula = element.input1_isformula != undefined ? element.input1_isformula : false;

    var input2_minvalue = element.input2_minvalue != undefined ? element.input2_minvalue : 0;
    var input2_maxvalue = element.input1_maxvalue != undefined ? element.input2_maxvalue : 100000;
    var input2_step = element.input2_maxdecimals != undefined ? generateStep(element.input2_maxdecimals) : 1;
    var input2_isFormula = element.input2_isformula != undefined ? element.input2_isformula : false;

    var conditionalDisplay = getConditionalDisplay(element)
    var elementCreated = "";
    var classInput1 = input1_isFormula ? "hide-element" : "";
    var classInput2 = input2_isFormula ? "hide-element" : "";
    let classInput1Element = input1_isFormula ? "lookup-element-with-formula" : "";
    let classInput2Element = input2_isFormula ? "lookup-element-with-formula" : "";

    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;

    let toolTipHtml= enableToolTip===true? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></span>"
                : "";

    elementCreated += "<div class='element " + classInput1 + "' data-element='" + element.Identifier + "_1' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.input1_label + toolTipHtml+ "</label><input onfocusout='onChange(null)' data-lookup='true' data-lookupelementindex='1' data-identifier='" + element.Identifier + "' class='calc-prop " + classInput1Element + "' step='" + input1_step + "' data-minvalue='" + input1_minvalue + "' min='" + input1_minvalue + "' max='" + input1_maxvalue + "' onblur='validity.valid || (value = \"\");' data-calcname='" + element.input1_label + "' data-isformula='" + input1_isFormula + "' data-formula='" + element.input1_formula + "' name=\"properties[" + element.input1_label + "]\" value='" + element.input1_minvalue + "' type='number'/></div>";
    elementCreated += "<div class='element " + classInput2 + "' data-element='" + element.Identifier + "_2' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.input2_label + toolTipHtml+ "</label><input onfocusout='onChange(null)' data-lookup='true' data-lookupelementindex='2' data-identifier='" + element.Identifier + "' class='calc-prop " + classInput2Element + "' step='" + input2_step + "' data-minvalue='" + input2_minvalue + "' min='" + input2_minvalue + "' max='" + input2_maxvalue + "' onblur='validity.valid || (value = \"\");' data-calcname='" + element.input2_label + "' data-isformula='" + input2_isFormula + "' data-formula='" + element.input2_formula + "' name=\"properties[" + element.input2_label + "]\" value='" + element.input2_minvalue + "' type='number'/></div>";

    return elementCreated;
}

function buildTextDisplayBlock(element) {
    var textValue = element.TextValue != undefined ? element.TextValue : '';
    var conditionalDisplay = getConditionalDisplay(element);
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let toolTipHtml= enableToolTip===true? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></span>"
    : "";

    return "<div class='element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + " ><label style='color:" + calculatorStyling.UpperTextColor + "'>" + textValue + toolTipHtml+ "</label></div>";
}

function buildImageElement(element) {
    var isrequired = element.isRequired;
    var conditionalDisplay = getConditionalDisplay(element);
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let toolTipHtml= enableToolTip===true? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></span>"
    : "";

    return "<div class='element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+ "</label><input id='fileinput' class='calc-prop' data-identifier='" + element.Identifier + "' data-isrequired='" + isrequired + "' type='file' name=\"properties[" + element.Name + "]\" /></div>";
}

function buildTextInput(element) {
    var minValue = element.MinCharacters != undefined ? element.MinCharacters : 0;
    var maxValue = element.MaxCharacters != undefined ? element.MaxCharacters : 100000;
    var isrequired = element.isRequired;
    var conditionalDisplay = getConditionalDisplay(element);
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let toolTipHtml= enableToolTip===true? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></span>"
    : "";

    return "<div class='element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+"</label><textarea class='calc-prop' data-isrequired='" + isrequired + "' minlength='" + minValue + "' maxlength='" + maxValue + "' onblur='validity.valid || (value = \"\");' data-calcname='" + element.Name + "' name=\"properties[" + element.Name + "]\" placeholder='" + element.Placeholder + "'></textarea></div>";
}

function buildCheckboxInput(element) {
    var checkedValue = element.checkedValue;
    var uncheckedValue = element.uncheckedValue;
    var conditionalDisplay = getConditionalDisplay(element);
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let toolTipHtml= enableToolTip===true? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></div>"
    : "";

    return "<div class='element checkbox-element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + "'><input class='calc-prop checkbox' data-identifier='" + element.Identifier + "' onchange='onChange(null)' type='checkbox' value='" + checkedValue + "' name=\"properties[" + element.Name + "]\" data-calcname='" + element.Name + "' data-checkedvalue='" + checkedValue + "' data-uncheckedvalue='" + uncheckedValue + "'/><span style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+"</span></div>";
}

function buildVariantElement() {
    return "<input id='variantIdCustom' name='id' type='hidden' value='0' />";
}

function buildDropDown(element) {
    var conditionalDisplay = getConditionalDisplay(element)
    var parsedName = element.Name.replace(/"/g, '&quot;');
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let toolTipHtml= enableToolTip===true? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></div>"
    : "";
    
    var ddl = "<div class='element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+"</label><select style='border:1px solid yellow' data-identifier='" + element.Identifier + "' onchange='onChange(null, this)' class='calc-prop' data-calcname='" + parsedName + "' name=\"properties[" + parsedName + "]\">";

    element.Options.forEach(option => {
        ddl += "<option data-val='" + option.value + "'>" + option.label + "</option>";
    });
    ddl += "</select ></div >";

    //if (element.SubNav !== null && element.SubNav !== undefined) {
    //    var subNavDdl = "<div class='element'><label>" + element.SubNav + "</label><select id='subnav-" + element.Identifier + "' class='calc-prop' name='" + element.SubNav + "'>";
    //    element.Options[0].options.forEach(option => {
    //        subNavDdl += "<option>" + option + "</option>";
    //    });
    //    subNavDdl += "</select ></div > ";
    //    ddl += subNavDdl;
    //}

    return ddl;
}

function buildImageSelector(element) {
    var conditionalDisplay = getConditionalDisplay(element)
    var enableSwatch = element.enableSwatch;
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let toolTipHtml= enableToolTip===true? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></div>"
    : "";
    var ddl='';
    if (enableSwatch === false) {
            ddl = "<div class='element' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+"</label><select style='border:1px solid yellow' data-showimage='" + element.showImage + "' data-identifier='" + element.Identifier + "' onchange='onChange(\"" + element.ElementType + "\", this)' class='calc-prop' data-calcname='" + element.Name + "' name=\"properties[" + element.Name + "\">";
        
        element.Options.forEach(option => {
            ddl += "<option data-val='" + option.value + "' data-imgsrc='" + option.filepath + "'  >" + option.label + "</option>";
        });
        ddl += "</select ></div>";
        element.Options.forEach(option => {
            ddl += "<img src='" + option.filepath + "' style='display:none' />";
        });
    } else {
            ddl="<div class='element' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+ "</label><fieldset class='swatch-picker'>";
        
        let swatchIndex = 0;
        element.Options.forEach(option => {
            swatchIndex++;
            let swatchedChecked = swatchIndex === 1 ? 'checked' : ''
            ddl += "<labele class='swatch-label ctooltip' title='" + option.label + "'><input type='radio' class='calc-prop' data-identifier='" + element.Identifier + "' " + swatchedChecked + " data-showimage='" + element.showImage + "' value='" + option.label + "' data-val='" + option.value + "' data-imgsrc='" + option.filepath + "' data-calcname='" + element.Name + "' name=\"properties[" + element.Name + "]\" onchange='onChange(\"" + element.ElementType + "\", this)' /><img src='" + option.filepath + "' /></labele>";
        });
        ddl += "</fieldset></div>";
    }
    return ddl;
}

function getConditionalDisplay(element) {
    var showElement = element.conditional_display === true ? false : true;
    var displayStyle = showElement === false ? "style='display:none;'" : "";
    var conditionalElement = element.conditional_display_selected_element;
    var conditionalElementValue = element.conditional_display_selected_element_value;

    return {
        'displayStyle': displayStyle,
        'conditionalElement': conditionalElement,
        'conditionalElementValue': conditionalElementValue,
        'conditionalTemplate': displayStyle + " data-conditionalelement='" + conditionalElement + "' data-conditionalelementvalue='" + conditionalElementValue + "'"
    };
}

function buildCalculationElement(element) {
    let formulaResult = parseFloat(element.formula_minvalue);
    formulaResult = Number(formulaResult).toFixed(element.formula_decimals);
    var conditionalDisplay = getConditionalDisplay(element);
    let isQuantity= element.isQuantity != undefined ? element.isQuantity : false;
    var processedElementName = element.Name.replace(spaceRegex, '_');
    processedElementName = processedElementName.replace(specialCharactersRegex, '');
    let enableToolTip= element.enableToolTip != undefined ? element.enableToolTip : false;
    let toolTip= enableToolTip?element.toolTip:null;
    let toolTipHtml= enableToolTip===true? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>"+toolTip+"<i></i></span></div>"
    : "";
    return "<div class='element' data-element='" + element.Identifier + "' " + conditionalDisplay.conditionalTemplate + "><label style='color:" + calculatorStyling.UpperTextColor + "'>" + element.Name + toolTipHtml+ "</label><span class='formula-block'> " + element.formula_prefix + " <label class='calculation-element calc-prop' name=\"properties[" + element.Name + "]\" data-minvalue='" + element.formula_minvalue + "' data-element_name='" + element.Name + "' data-val='" + element.formula_minvalue + "' data-decimals='" + element.formula_decimals + "' data-formula='" + element.formula + "' data-cpc_isquantity='"+isQuantity+"' id='formula_" + element.Name + "'>" + formulaResult + "</label><suffix>" + element.formula_suffix + "</suffix></span></div><input type='hidden' id='calculation_inp_" + processedElementName + "' name=\"properties[" + element.Name + "]\" data-cpc_isquantity='"+isQuantity+"' value='" + element.formula_minvalue + "' />";
}

function buildPriceMarker(element) {
    cpc_currentPrice = element.DefaultValue;
    priceMarkerDecimals = element.Decimals;
    miniMumCartValue = parseFloat(element.DefaultValue);
    miniMumCartValue = Number(miniMumCartValue).toFixed(element.Decimals);
    var borderClass = calculatorStyling.Border === 'rounded' ? "rounded-edges-bottom" : "";
    var errorBlock = buildErrorBlock();
    var dialogBlock = buildDialogBlock();
    if (calculatorStyling.LoaderText === null)
        calculatorStyling.LoaderText = "";
    var loadingAnim = "<div class='loading-anim' style='display:none'><img src='https://calcapi.printgrid.io/file/loading-spinner.gif'><p id='cpc_loader_text'>" + calculatorStyling.LoaderText + "</p></div>";
    return errorBlock + dialogBlock + loadingAnim + "<div class='price-marker " + borderClass + "' style='background-color:" + calculatorStyling.PriceBackground + ";color:" + calculatorStyling.PriceTextColor + "'><label style='color:" + calculatorStyling.PriceTextColor + "'>" + element.Name + "</label><span id='calculator-final-value'> " + element.Prefix + " <label id='priceTicker' style='color:" + calculatorStyling.PriceTextColor + "'>" + miniMumCartValue + "</label><suffix>" + element.Suffix + "</suffix></span></div>";
}

;

function CheckNumberInputValidity(element)
{
      let alertMessage= cpc_configData.AlertMessageNumberInput;
      let inValidCount=0; 
      let inValidProp=''; 
      let isValid= true;
      if(!element.validity.valid)
      {
        for(var key in element.validity){
                if(element.validity[key])
                {
                    inValidCount++; 
                    inValidProp= key.toLowerCase();
                }
            }
      }
    if(inValidCount>1 || (inValidCount == 1 && inValidProp!='stepmismatch'))
        isValid=false;

    if (element.value.length==0 || !isValid) {
        element.setAttribute("style","border:1px solid red !important;");
        element.value=element.min||0;
        if(element.nextSibling==null)
        {
          if(alertMessage.replace('{input_range_min}','').replace('{input_range_max}','').trim().length>0)
          {
            let min= element.getAttribute('min');
            let max= element.getAttribute('max');
            alertMessage= alertMessage.replace('{input_range_min}',min).replace('{input_range_max}',max).trim();
            element.insertAdjacentHTML("afterend","<label style='color:red;'>"+alertMessage+"</label>");
          }
          else
            element.insertAdjacentHTML("afterend","<label style='color:red;'>Value out of range</label>");
        }
        UpdatePrice();
        return false;
        } 
        
    element.style.setProperty("border","");
    
    if(element.nextSibling!=null)
        element.nextSibling.remove();
    
    UpdatePrice();
    return true;
}


function PreventCheckoutOnEnter(){
    $("#calculator").on("keypress", function (event) {
        console.log("checking for enter whether preseed for form.");
        var keyPressed = event.keyCode || event.which;
        if (keyPressed === 13) {
            console.log("Found Enter pressed for form.");
            event.preventDefault();
            return false;
        }
    });
}

$(window).ready(function() {
    PreventCheckoutOnEnter();
});



﻿function firstLoad() {
    let productForm;
  jQuery('form[action*="/cart/add"]').each(function(i,e){
    if(productForm === undefined && e.querySelector('[type="submit"]'))
    {
      productForm=e;
    }
    if (productForm === undefined && e.querySelector('button[class*="cart"]'))
    {
        productForm=e;
    }

  });
    var radio = productForm.querySelector("input[type='radio']:checked")
    var dropDownImageSelector = productForm.querySelector("select[data-showimage='true']")
    if (radio !== undefined && radio !== null) {
        imageddlChange(radio)
    } else if (dropDownImageSelector !== undefined && dropDownImageSelector !== null) {
        imageddlChange(dropDownImageSelector)
    }
    ProcessConditionalElements();
    UpdatePrice();
    PreventCheckoutOnEnter();
}

/*Every element change event will trigger this method */
function onChange(elementType, domElement = null) {
    if (elementType === 'ImageSelector') {
        imageddlChange(domElement)
    }
    ProcessConditionalElements();
    UpdatePrice();
}

function imageddlChange(element) {
    let isRadio = jQuery(element).is(":radio");
    var showImage = jQuery(element).data('showimage');
    if (isRadio === true) {
        //Swatch
        if (showImage === true) {
            let imgsrc = jQuery(element).data('imgsrc');
            UpdateProductImage(imgsrc)
        }
    } else {
        //Dropdown
        if (showImage === true) {
            let imgsrc = jQuery(element).children("option:selected").data('imgsrc');
            UpdateProductImage(imgsrc)
        }
    }
}

function UpdateProductImage(imgSrc) {
    var imageSelectors = document.querySelectorAll('[class^=product]>img');
    let isImageUpdated = false;
    let isPresentationUpdated = false;
    imageSelectors.forEach(elem => {
        if (isImageUpdated === false) {
            var calcSet = elem.getAttribute('calcset');
            var dataIndex = elem.getAttribute("data-index");
            var isDataIndexConditionSatisfied = dataIndex === null || dataIndex === '1'
            if ((elem.src.includes('cdn.shopify.com') || elem.srcset.includes('cdn.shopify.com') || calcSet === "true") && isDataIndexConditionSatisfied === true) {
                isImageUpdated = true;
                elem.setAttribute('src', imgSrc);
                elem.setAttribute('calcset', true);
                elem.setAttribute('data-srcset', '');
                elem.setAttribute('data-zoom', imgSrc);
                elem.setAttribute('srcset', '');
            }
        } else if (isImageUpdated === true && isPresentationUpdated === false) {
            var imageElement = document.querySelector('img[role="presentation"]')
            if (imageElement !== null && imageElement !== undefined) {
                isPresentationUpdated = true;
                imageElement.setAttribute('src', imgSrc);
                imageElement.setAttribute('calcset', true);
                imageElement.setAttribute('data-zoom', imgSrc);
                imageElement.setAttribute('data-srcset', '');
                imageElement.setAttribute('srcset', '');
            }
        }
    });
}

function ProcessConditionalElements() {
    jQuery('.element').each((d, elem) => {
        let conditionalElement = jQuery(elem).data('conditionalelement');
        let conditionalElementValue = jQuery(elem).data('conditionalelementvalue');
        if (conditionalElement !== undefined && conditionalElement !== null) {
            //Check if conditional Element is select
            var escapedConditionalElement = globalHelper_Escape(conditionalElement)
            let selectConditionalElement = document.querySelector('select[data-identifier="' + escapedConditionalElement + '"]')
            let radioConditionalElement = document.querySelector('input[type="radio"][data-identifier="' + escapedConditionalElement + '"]:checked')
            let checkboxConditionalElement = document.querySelector('input[type="checkbox"][data-identifier="' + escapedConditionalElement + '"]')
            let selectedValue = null;
            let isHidden = false;
            if (selectConditionalElement !== null) {
                selectedValue = jQuery(selectConditionalElement).val()
                isHidden = jQuery(selectConditionalElement).is(':hidden');
                // console.log('selectedValue', selectedValue)
            } else if (radioConditionalElement !== null) {
                selectedValue = jQuery(radioConditionalElement).val()
                isHidden = jQuery(radioConditionalElement).is(':hidden');
            } else if (checkboxConditionalElement !== null) {
                selectedValue = jQuery(checkboxConditionalElement).is(":checked") === true ? "Checked" : "Unchecked";
                isHidden = jQuery(checkboxConditionalElement).is(':hidden');
                // console.log('checkbox', checkboxConditionalElement)
            }

            //Show hide the conditional element if the value matches
            if (selectedValue !== null) {
                if (selectedValue == conditionalElementValue && isHidden === false) {
                    jQuery(elem).show();
                    jQuery(elem).find('.calc-prop').show();
                } else {
                    jQuery(elem).hide();
                    jQuery(elem).find('.calc-prop').hide();
                }
            }
        }
    });
}

function UpdatePrice() {
    var formulaBeforeEval = "";
    try {
        var formula = cpc_data.Formula;
        EvaluateFormulaElements();

        //console.log('before-formula', formula)
        formula = FormulaParser(formula);
        if (formula === 'NaN') formula = miniMumCartValue;
        //console.log('after-formula', formula)
        formulaBeforeEval = formula;
        var evaluatedNewPrice = eval(formula)
        //console.log('evaluated price', evaluatedNewPrice)
        var finalValue = Math.max(miniMumCartValue, evaluatedNewPrice)
        if (finalValue != cpc_currentPrice && !isNaN(finalValue)) {
            //document.getElementById('priceTicker').innerHTML = jj;
            jQuery('#priceTicker').prop('Counter', cpc_currentPrice).animate({
                Counter: finalValue
            }, {
                duration: 200,
                easing: 'swing',
                step: function (now) {
                    jQuery(this).html(Number(now).toFixed(priceMarkerDecimals));
                }
            });
            cpc_currentPrice = finalValue
        }

        EvaluateCalculationElements();
    }
    catch (e) {
        var msg = "FormulaBeforeEval = " + formulaBeforeEval;
        globalHelper_ReportError(e, msg);
    }
}

//This will evaluate form
function EvaluateFormulaElements() {
    jQuery('.lookup-element-with-formula').each((d, elem) => {
        //console.log('lookup-element-',elem);
        let elem_formula = jQuery(elem).data("formula");
        let elem_formula_minvalue = jQuery(elem).data("minvalue");
        let parsedFormula = FormulaParser(elem_formula.toString())
        let evaluatedValue = eval(parsedFormula)
        let elem_finalValue = Math.max(elem_formula_minvalue, evaluatedValue)
        //console.log('formula 2', elem_finalValue)
        elem.setAttribute("value", elem_finalValue);
    });
}

function EvaluateCalculationElements() {
    jQuery('.calculation-element').each((d, elem) => {
        let elem_formula = jQuery(elem).data("formula");
        let elem_formula_minvalue = jQuery(elem).data("minvalue");
        let elem_current_value = jQuery(elem).data("val");
        let elem_decimals = jQuery(elem).data("decimals");
        let element_name = jQuery(elem).data("element_name");
        let parsedFormula = FormulaParser(elem_formula.toString())
        let evaluatedValue = eval(parsedFormula)
        let elem_finalValue = Math.max(elem_formula_minvalue, evaluatedValue)
        if (elem_finalValue != elem_current_value && !isNaN(elem_finalValue)) {
            jQuery(elem).prop('Counter', elem_current_value).animate({
                Counter: elem_finalValue
            }, {
                duration: 200,
                easing: 'swing',
                step: function (now) {
                    jQuery(elem).html(Number(now).toFixed(elem_decimals));
                }
            });
            jQuery(elem).data('val', elem_finalValue)
            element_name = element_name.replace(spaceRegex, '_')
            element_name = element_name.replace(specialCharactersRegex, '')
            jQuery('#calculation_inp_' + element_name).val(Number(elem_finalValue).toFixed(elem_decimals));
            elem_current_value = elem_finalValue
        }
    });
}

function FormulaParser(formula) {
    try {
        formula = formula.toLowerCase()
        var mathRegexPattern = new RegExp("math.", "g");
        formula = !!formula ? formula.toString().replaceAll(mathRegexPattern, 'Math.') : '';
        formula = !!formula ? formula.toString().replaceAll('shopify_product_price', cpc_product_default_price) : '';

        //apply meta fields
        cpc_metaFields.forEach(item => {
            formula = !!formula ? formula.toString().replaceAll('shopify_meta_' + item.key, item.value) : '';
        });

        //Apply to remaining meta fields
        var metaRegexPattern = new RegExp("shopify_meta_(.*?)([*\/+-]|$)", "g");
        do {
            m = metaRegexPattern.exec(formula);
            if (m) {
                if (m.length > 1) {
                    var metaVariableName = m[1];
                    formula = !!formula ? formula.toString().replaceAll('shopify_meta_' + metaVariableName, 1) : '';
                    console.log('meta_variable_name', metaVariableName);
                }
            }
        } while (m);

        //formula = formula.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "")
        var allElements = jQuery(jQuery('.calc-prop').get())
        var allElements = jQuery(jQuery('.calc-prop').get())
        allElements = allElements.sort((a, b) => {
            if (jQuery(a).data('identifier') === undefined) return 1;
            else if (jQuery(b).data('identifier') === undefined) return -1;
            else return jQuery(a).data('identifier').length > jQuery(b).data('identifier').length ? -1 : 1;
        })

        var lookupElements = {};
        allElements.each((d, elem) => {
            let isHidden = jQuery(elem).is(':hidden');
            let isCheckBox = jQuery(elem).is(":checkbox");
            let isRadio = jQuery(elem).is(":radio");
            var elementType = jQuery(elem).prop('nodeName');
            let identifier = jQuery(elem).data('calcname');
            let rangeEnabled = jQuery(elem).data('rangeenabled');
            let isLookupElement = jQuery(elem).data('lookup') !== undefined;
            let IsLookupFormulaElement = isLookupElement ? jQuery(elem).data('isformula') === true : false;
            // console.log('isLookupElement', isLookupElement);
            if (identifier === undefined) return;
            if (identifier !== undefined) {
                var regexPattern = generateSafeRegex(identifier);

                if (isHidden === false || (IsLookupFormulaElement === true && jQuery(elem).css("display") != "none")) {
                    if (elementType == 'SELECT') {
                        let value = jQuery(elem).children("option:selected").data('val');
                        formula = formula.replace(regexPattern, value);
                    }
                    else if (elementType == 'INPUT' && rangeEnabled === true) {
                        let value = jQuery(elem).val()
                        value = parseFloat(value)

                        var options = cpc_data.Elements
                        let finalInputValue = value
                        options.forEach(element => {
                            if (element.Identifier === identifier) {
                                var rangeOptions = element.options
                                rangeOptions.forEach(element => {
                                    if (value >= parseFloat(element.start) && value <= parseFloat(element.end)) {
                                        finalInputValue = parseFloat(element.value)
                                    }
                                })
                            }
                        })

                        //Handle case for actual value
                        let actualValueIdentifier = identifier + '[ActualValue]'
                        var actualValueRegex = generateSafeRegex(actualValueIdentifier);
                        formula = formula.replace(actualValueRegex, value);

                        //Range handling
                        finalInputValue = parseFloat(finalInputValue, 10)
                        formula = formula.replace(regexPattern, finalInputValue);
                    }
                    else if (isCheckBox === true) {
                        let isChecked = jQuery(elem).is(":checked")
                        let checkedValue = jQuery(elem).data("checkedvalue")
                        let uncheckedValue = jQuery(elem).data("uncheckedvalue")
                        var valueToBeUsed = isChecked ? checkedValue : uncheckedValue;
                        //console.log('checkedValue', valueToBeUsed)
                        formula = formula.replace(regexPattern, valueToBeUsed);
                    }
                    else if (isRadio === true) {
                        let isChecked = jQuery(elem).is(":checked")
                        if (isChecked === true) {
                            let value = jQuery(elem).data('val');
                            formula = formula.replace(regexPattern, value);
                        }
                    }
                    else if (isLookupElement === true) {
                        let lookupelementindex = jQuery(elem).data("lookupelementindex")
                        let elementIdentifier = jQuery(elem).data("identifier");
                        if (typeof lookupElements[elementIdentifier] === 'undefined') {
                            var lookupElementProcessedElement = {
                                elementName: elementIdentifier,
                                input1_label: '',
                                input1: 0,
                                input2_label: '',
                                input2: 0
                            };

                            if (lookupelementindex === 1) {
                                lookupElementProcessedElement.input1 = parseFloat(jQuery(elem).val(), 10);
                                lookupElementProcessedElement.input1_label = identifier;
                            }
                            else if (lookupelementindex === 2) {
                                lookupElementProcessedElement.input2 = parseFloat(jQuery(elem).val(), 10);
                                lookupElementProcessedElement.input2_label = identifier;
                            }

                            lookupElements[elementIdentifier] = lookupElementProcessedElement;
                        }
                        else {
                            let lookupElementProcessedElement = lookupElements[elementIdentifier];
                            if (lookupelementindex === 1) {
                                lookupElementProcessedElement.input1 = jQuery(elem).val();
                                lookupElementProcessedElement.input1_label = identifier;
                            }
                            else if (lookupelementindex === 2) {
                                lookupElementProcessedElement.input2 = jQuery(elem).val();
                                lookupElementProcessedElement.input2_label = identifier;
                            }
                            //console.log('lookupElementProcessedElement', lookupElementProcessedElement);
                        }
                    }
                    else {
                        //console.log('regexPattern', regexPattern);
                        //console.log('formula 5', formula);
                        let value = jQuery(elem).val()
                        value = parseFloat(value, 10)
                        formula = formula.replace(regexPattern, value);
                    }
                }
                //If the elemnt is not visible, take the not visible value
                else {
                    var elementLookupResult = cpc_data.Elements.filter(function (item, idx) {
                        if (item.Name === identifier) return item;
                    });

                    //If the element is hidden then use default value
                    if (elementLookupResult.length > 0) {
                        let value = elementLookupResult[0].value_when_not_displayed
                        if (value === undefined) value = 1;

                        //Handle special case for Actual value for range input
                        if (elementType == 'INPUT') {
                            let actualValueIdentifier = identifier + '[ActualValue]'
                            var actualValueRegex = generateSafeRegex(actualValueIdentifier);
                            formula = formula.replace(actualValueRegex, value);
                        }

                        formula = formula.replace(regexPattern, value);
                    }

                    //Special handling for lookup element that is hidden
                    if (isLookupElement === true) {
                        let lookupelementindex = jQuery(elem).data("lookupelementindex")
                        let lookupElementName = jQuery(elem).data('identifier');
                        let lookupElementResult = cpc_data.Elements.filter(function (item, idx) {
                            if (item.Name === lookupElementName) return item;
                        });
                        if (lookupElementResult.length > 0) {
                            let lookupElementIdentifier = lookupElementName + '[' + identifier + ']';
                            regexPattern = generateSafeRegex(lookupElementIdentifier);
                            formula = formula.replace(regexPattern, 0);

                            //Update the main element value when both elements are parsed
                            if (lookupelementindex === 2) {
                                let value = lookupElementResult[0].value_when_not_displayed
                                if (value === undefined) value = 1;
                                regexPattern = generateSafeRegex(lookupElementName);
                                value = parseFloat(value, 10)
                                formula = formula.replace(regexPattern, value);
                            }
                        }
                    }
                }
            }
        })

        //Now process lookup element
        for (var key in lookupElements) {
            let currentLookupElementData = lookupElements[key];
            var elementData = getCurrentElementDataByIdenfier(key);

            //Replace sub elements
            let lookupElementIdentifier1 = currentLookupElementData['elementName'] + '[' + currentLookupElementData['input1_label'] + ']';
            let lookupElementIdentifier2 = currentLookupElementData['elementName'] + '[' + currentLookupElementData['input2_label'] + ']';
            let regexPattern = generateSafeRegex(lookupElementIdentifier1);
            formula = formula.replace(regexPattern, currentLookupElementData['input1']);
            regexPattern = generateSafeRegex(lookupElementIdentifier2);
            formula = formula.replace(regexPattern, currentLookupElementData['input2']);

            let xIndex = elementData.sheet_data.input1_range.length - 1;
            let yIndex = elementData.sheet_data.input2_range.length - 1;
            for (let step = 0; step < elementData.sheet_data.input1_range.length - 1; step++) {
                if (parseFloat(currentLookupElementData.input1) >= parseFloat(elementData.sheet_data.input1_range[step]) && parseFloat(currentLookupElementData.input1) < parseFloat(elementData.sheet_data.input1_range[step + 1])) {
                    xIndex = step;
                    break;
                }
            }
            for (let step = 0; step < elementData.sheet_data.input2_range.length - 1; step++) {
                if (parseFloat(currentLookupElementData.input2) >= parseFloat(elementData.sheet_data.input2_range[step]) && parseFloat(currentLookupElementData.input2) < parseFloat(elementData.sheet_data.input2_range[step + 1])) {
                    yIndex = step;
                    break;
                }
            }

            //If the input is greater than the range then take the last element
            if (xIndex === 0 && parseFloat(currentLookupElementData.input1) > parseFloat(elementData.sheet_data.input1_range[elementData.sheet_data.input1_range.length - 1])) {
                xIndex = elementData.sheet_data.input1_range.length - 1;
            }
            //If the input is greater than the range then take the last element
            if (yIndex === 0 && parseFloat(currentLookupElementData.input2) > parseFloat(elementData.sheet_data.input2_range[elementData.sheet_data.input2_range.length - 1])) {
                yIndex = elementData.sheet_data.input2_range.length - 1;
            }

            let value = elementData.sheet_data.data_lookup[yIndex][xIndex];
            regexPattern = generateSafeRegex(key);
            formula = formula.replace(regexPattern, value);
        }

        //console.log(formula);
        return formula;
    }
    catch (e) {
        globalHelper_ReportError(e);
    }
}

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


var PriceUpdation = debounce(function(element) {
            UpdatePrice();
    
}, 500);


﻿
function ValidateInputs() {
    var isError = false;
    jQuery('.calc-prop').each((d, elem) => {
        let isHidden = jQuery(elem).is(':hidden');
        if (isHidden === false) {
            let value = jQuery(elem).val();
            let isRequired = jQuery(elem).data('isrequired');
            if (isRequired !== undefined && isRequired == true && value.length <= 0) {
                isError = true;
                jQuery(elem).addClass('error-border');
            }
        }
    })

    setTimeout(() => {
        ResetInputs();
    }, 3000);

    return isError;
}

function getCurrentElementDataByIdenfier(identifier) {
    var allelements = cpc_data.Elements
    var finalElement = null;
    allelements.forEach(element => {
        if (element.Identifier === identifier) {
            finalElement = element;
        }
    })
    return finalElement;
}

function generateSafeRegex(identifier) {
    identifierForFormula = identifier.toLowerCase()
    identifierForFormula = identifierForFormula.replace(/\(/g, "\\("); // (
    identifierForFormula = identifierForFormula.replace(/\)/g, "\\)"); // )
    identifierForFormula = identifierForFormula.replace(/\[/g, "\\["); // [
    identifierForFormula = identifierForFormula.replace(/\]/g, "\\]"); // ]
    identifierForFormula = identifierForFormula.replace(/\?/g, "\\?"); // ?
    identifierForFormula = identifierForFormula.replace(/\//g, "\\/"); // /
    identifierForFormula = identifierForFormula.replace(/\+/g, "\\+"); // +
    var regexPattern = new RegExp(identifierForFormula, "g");
    return regexPattern;
}

function ResetInputs() {
    jQuery('.calc-prop').each((d, elem) => {
        jQuery(elem).removeClass('error-border');
    })
}

function UpdateAllSelectedCheckBox() {
    jQuery('.checkbox-element .checkbox:checked').each((d, elem) => {
        jQuery(elem).val('Yes');
    })
}

function UpdateAllHiddenElements() {
    jQuery('#calculator .element:hidden').each((d, elem) => {
        jQuery(elem).remove();
    })
}

function loadScripts() {
    //CSS
    var fileref = document.createElement("link")
    fileref.setAttribute("rel", "stylesheet")
    fileref.setAttribute("type", "text/css")
    fileref.setAttribute("href", 'https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/themes/cupertino/jquery-ui.min.css')
    //shopUrl
    document.getElementsByTagName("head")[0].appendChild(fileref)

    //JS
    var fileref1 = document.createElement("script")
    fileref1.setAttribute("src", '//code.jquery.com/ui/1.12.1/jquery-ui.js')
    document.getElementsByTagName("head")[0].appendChild(fileref1)

    //FontAwesome JS
    var fontAwesomeRef = document.createElement("script");
    fontAwesomeRef.setAttribute("src", '//kit.fontawesome.com/9824551a84.js');
    fontAwesomeRef.setAttribute("crossorigin",'anonymous');
    document.getElementsByTagName("head")[0].appendChild(fontAwesomeRef);

    
 

    //var fileref2 = document.createElement("script")
    //fileref2.setAttribute("src", baseCalculatorApiUrl + '/shopify/common_resource.js')
    //document.getElementsByTagName("head")[0].appendChild(fileref2)
}


function getCurrencyFormat(currencyCode) {
  var currencyCodeUpperCase = currencyCode.toUpperCase();
  switch (currencyCodeUpperCase) {
    case "USD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} USD",
      };
      break;
    case "EUR":
      return {
        money_format: "&euro;{{amount}}",
        money_with_currency_format: "&euro;{{amount}} EUR",
      };
      break;
    case "GBP":
      return {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} GBP",
      };
      break;
    case "CAD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} CAD",
      };
      break;
    case "ALL":
      return {
        money_format: "Lek {{amount}}",
        money_with_currency_format: "Lek {{amount}} ALL",
      };
      break;
    case "DZD":
      return {
        money_format: "DA {{amount}}",
        money_with_currency_format: "DA {{amount}} DZD",
      };
      break;
    case "AOA":
      return {
        money_format: "Kz{{amount}}",
        money_with_currency_format: "Kz{{amount}} AOA",
      };
      break;
    case "ARS":
      return {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} ARS",
      };
      break;
    case "AMD":
      return {
        money_format: "{{amount}} AMD",
        money_with_currency_format: "{{amount}} AMD",
      };
      break;
    case "AWG":
      return {
        money_format: "Afl{{amount}}",
        money_with_currency_format: "Afl{{amount}} AWG",
      };
      break;
    case "AUD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} AUD",
      };
      break;
    case "BBD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} Bds",
      };
      break;
    case "AZN":
      return {
        money_format: "m.{{amount}}",
        money_with_currency_format: "m.{{amount}} AZN",
      };
      break;
    case "BDT":
      return {
        money_format: "Tk {{amount}}",
        money_with_currency_format: "Tk {{amount}} BDT",
      };
      break;
    case "BSD":
      return {
        money_format: "BS${{amount}}",
        money_with_currency_format: "BS${{amount}} BSD",
      };
      break;
    case "BHD":
      return {
        money_format: "{{amount}}0 BD",
        money_with_currency_format: "{{amount}}0 BHD",
      };
      break;
    case "BYR":
      return {
        money_format: "Br {{amount}}",
        money_with_currency_format: "Br {{amount}} BYR",
      };
      break;
    case "BZD":
      return {
        money_format: "BZ${{amount}}",
        money_with_currency_format: "BZ${{amount}} BZD",
      };
      break;
    case "BTN":
      return {
        money_format: "Nu {{amount}}",
        money_with_currency_format: "Nu {{amount}} BTN",
      };
      break;
    case "BAM":
      return {
        money_format: "KM {{amount_with_comma_separator}}",
        money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
      };
      break;
    case "BRL":
      return {
        money_format: "R$ {{amount_with_comma_separator}}",
        money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
      };
      break;
    case "BOB":
      return {
        money_format: "Bs{{amount_with_comma_separator}}",
        money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
      };
      break;
    case "BWP":
      return {
        money_format: "P{{amount}}",
        money_with_currency_format: "P{{amount}} BWP",
      };
      break;
    case "BND":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} BND",
      };
      break;
    case "BGN":
      return {
        money_format: "{{amount}} лв",
        money_with_currency_format: "{{amount}} лв BGN",
      };
      break;
    case "MMK":
      return {
        money_format: "K{{amount}}",
        money_with_currency_format: "K{{amount}} MMK",
      };
      break;
    case "KHR":
      return {
        money_format: "KHR{{amount}}",
        money_with_currency_format: "KHR{{amount}}",
      };
      break;
    case "KYD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} KYD",
      };
      break;
    case "XAF":
      return {
        money_format: "FCFA{{amount}}",
        money_with_currency_format: "FCFA{{amount}} XAF",
      };
      break;
    case "CLP":
      return {
        money_format: "${{amount_no_decimals}}",
        money_with_currency_format: "${{amount_no_decimals}} CLP",
      };
      break;
    case "CNY":
      return {
        money_format: "&#165;{{amount}}",
        money_with_currency_format: "&#165;{{amount}} CNY",
      };
      break;
    case "COP":
      return {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} COP",
      };
      break;
    case "CRC":
      return {
        money_format: "&#8353; {{amount_with_comma_separator}}",
        money_with_currency_format:
          "&#8353; {{amount_with_comma_separator}} CRC",
      };
      break;
    case "HRK":
      return {
        money_format: "{{amount_with_comma_separator}} kn",
        money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
      };
      break;
    case "CZK":
      return {
        money_format: "{{amount_with_comma_separator}} K&#269;",
        money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
      };
      break;
    case "DKK":
      return {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "kr.{{amount_with_comma_separator}}",
      };
      break;
    case "DOP":
      return {
        money_format: "RD$ {{amount}}",
        money_with_currency_format: "RD$ {{amount}}",
      };
      break;
    case "XCD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "EC${{amount}}",
      };
      break;
    case "EGP":
      return {
        money_format: "LE {{amount}}",
        money_with_currency_format: "LE {{amount}} EGP",
      };
      break;
    case "ETB":
      return {
        money_format: "Br{{amount}}",
        money_with_currency_format: "Br{{amount}} ETB",
      };
      break;
    case "XPF":
      return {
        money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} XPF",
      };
      break;
    case "FJD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "FJ${{amount}}",
      };
      break;
    case "GMD":
      return {
        money_format: "D {{amount}}",
        money_with_currency_format: "D {{amount}} GMD",
      };
      break;
    case "GHS":
      return {
        money_format: "GH&#8373;{{amount}}",
        money_with_currency_format: "GH&#8373;{{amount}}",
      };
      break;
    case "GTQ":
      return {
        money_format: "Q{{amount}}",
        money_with_currency_format: "{{amount}} GTQ",
      };
      break;
    case "GYD":
      return {
        money_format: "G${{amount}}",
        money_with_currency_format: "${{amount}} GYD",
      };
      break;
    case "GEL":
      return {
        money_format: "{{amount}} GEL",
        money_with_currency_format: "{{amount}} GEL",
      };
      break;
    case "HNL":
      return {
        money_format: "L {{amount}}",
        money_with_currency_format: "L {{amount}} HNL",
      };
      break;
    case "HKD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "HK${{amount}}",
      };
      break;
    case "HUF":
      return {
        money_format: "{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} Ft",
      };
      break;
    case "ISK":
      return {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr ISK",
      };
      break;
    case "INR":
      return {
        money_format: "Rs. {{amount}}",
        money_with_currency_format: "Rs. {{amount}}",
      };
      break;
    case "IDR":
      return {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "Rp {{amount_with_comma_separator}}",
      };
      break;
    case "ILS":
      return {
        money_format: "{{amount}} NIS",
        money_with_currency_format: "{{amount}} NIS",
      };
      break;
    case "JMD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} JMD",
      };
      break;
    case "JPY":
      return {
        money_format: "&#165;{{amount_no_decimals}}",
        money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
      };
      break;
    case "JEP":
      return {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} JEP",
      };
      break;
    case "JOD":
      return {
        money_format: "{{amount}}0 JD",
        money_with_currency_format: "{{amount}}0 JOD",
      };
      break;
    case "KZT":
      return {
        money_format: "{{amount}} KZT",
        money_with_currency_format: "{{amount}} KZT",
      };
      break;
    case "KES":
      return {
        money_format: "KSh{{amount}}",
        money_with_currency_format: "KSh{{amount}}",
      };
      break;
    case "KWD":
      return {
        money_format: "{{amount}}0 KD",
        money_with_currency_format: "{{amount}}0 KWD",
      };
      break;
    case "KGS":
      return {
        money_format: "лв{{amount}}",
        money_with_currency_format: "лв{{amount}}",
      };
      break;
    case "LVL":
      return {
        money_format: "Ls {{amount}}",
        money_with_currency_format: "Ls {{amount}} LVL",
      };
      break;
    case "LBP":
      return {
        money_format: "L&pound;{{amount}}",
        money_with_currency_format: "L&pound;{{amount}} LBP",
      };
      break;
    case "LTL":
      return {
        money_format: "{{amount}} Lt",
        money_with_currency_format: "{{amount}} Lt",
      };
      break;
    case "MGA":
      return {
        money_format: "Ar {{amount}}",
        money_with_currency_format: "Ar {{amount}} MGA",
      };
      break;
    case "MKD":
      return {
        money_format: "ден {{amount}}",
        money_with_currency_format: "ден {{amount}} MKD",
      };
      break;
    case "MOP":
      return {
        money_format: "MOP${{amount}}",
        money_with_currency_format: "MOP${{amount}}",
      };
      break;
    case "MVR":
      return {
        money_format: "Rf{{amount}}",
        money_with_currency_format: "Rf{{amount}} MRf",
      };
      break;
    case "MXN":
      return {
        money_format: "$ {{amount}}",
        money_with_currency_format: "$ {{amount}} MXN",
      };
      break;
    case "MYR":
      return {
        money_format: "RM{{amount}} MYR",
        money_with_currency_format: "RM{{amount}} MYR",
      };
      break;
    case "MUR":
      return {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} MUR",
      };
      break;
    case "MDL":
      return {
        money_format: "{{amount}} MDL",
        money_with_currency_format: "{{amount}} MDL",
      };
      break;
    case "MAD":
      return {
        money_format: "{{amount}} dh",
        money_with_currency_format: "Dh {{amount}} MAD",
      };
      break;
    case "MNT":
      return {
        money_format: "{{amount_no_decimals}} &#8366",
        money_with_currency_format: "{{amount_no_decimals}} MNT",
      };
      break;
    case "MZN":
      return {
        money_format: "{{amount}} Mt",
        money_with_currency_format: "Mt {{amount}} MZN",
      };
      break;
    case "NAD":
      return {
        money_format: "N${{amount}}",
        money_with_currency_format: "N${{amount}} NAD",
      };
      break;
    case "NPR":
      return {
        money_format: "Rs{{amount}}",
        money_with_currency_format: "Rs{{amount}} NPR",
      };
      break;
    case "ANG":
      return {
        money_format: "&fnof;{{amount}}",
        money_with_currency_format: "{{amount}} NA&fnof;",
      };
      break;
    case "NZD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} NZD",
      };
      break;
    case "NIO":
      return {
        money_format: "C${{amount}}",
        money_with_currency_format: "C${{amount}} NIO",
      };
      break;
    case "NGN":
      return {
        money_format: "&#8358;{{amount}}",
        money_with_currency_format: "&#8358;{{amount}} NGN",
      };
      break;
    case "NOK":
      return {
        money_format: "kr {{amount_with_comma_separator}}",
        money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
      };
      break;
    case "OMR":
      return {
        money_format: "{{amount_with_comma_separator}} OMR",
        money_with_currency_format: "{{amount_with_comma_separator}} OMR",
      };
      break;
    case "PKR":
      return {
        money_format: "Rs.{{amount}}",
        money_with_currency_format: "Rs.{{amount}} PKR",
      };
      break;
    case "PGK":
      return {
        money_format: "K {{amount}}",
        money_with_currency_format: "K {{amount}} PGK",
      };
      break;
    case "PYG":
      return {
        money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
      };
      break;
    case "PEN":
      return {
        money_format: "S/. {{amount}}",
        money_with_currency_format: "S/. {{amount}} PEN",
      };
      break;
    case "PHP":
      return {
        money_format: "&#8369;{{amount}}",
        money_with_currency_format: "&#8369;{{amount}} PHP",
      };
      break;
    case "PLN":
      return {
        money_format: "{{amount_with_comma_separator}} zl",
        money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
      };
      break;
    case "QAR":
      return {
        money_format: "QAR {{amount_with_comma_separator}}",
        money_with_currency_format: "QAR {{amount_with_comma_separator}}",
      };
      break;
    case "RON":
      return {
        money_format: "{{amount_with_comma_separator}} lei",
        money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
      };
      break;
    case "RUB":
      return {
        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        money_with_currency_format:
          "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
      };
      break;
    case "RWF":
      return {
        money_format: "{{amount_no_decimals}} RF",
        money_with_currency_format: "{{amount_no_decimals}} RWF",
      };
      break;
    case "WST":
      return {
        money_format: "WS$ {{amount}}",
        money_with_currency_format: "WS$ {{amount}} WST",
      };
      break;
    case "SAR":
      return {
        money_format: "{{amount}} SR",
        money_with_currency_format: "{{amount}} SAR",
      };
      break;
    case "STD":
      return {
        money_format: "Db {{amount}}",
        money_with_currency_format: "Db {{amount}} STD",
      };
      break;
    case "RSD":
      return {
        money_format: "{{amount}} RSD",
        money_with_currency_format: "{{amount}} RSD",
      };
      break;
    case "SCR":
      return {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} SCR",
      };
      break;
    case "SGD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} SGD",
      };
      break;
    case "SYP":
      return {
        money_format: "S&pound;{{amount}}",
        money_with_currency_format: "S&pound;{{amount}} SYP",
      };
      break;
    case "ZAR":
      return {
        money_format: "R {{amount}}",
        money_with_currency_format: "R {{amount}} ZAR",
      };
      break;
    case "KRW":
      return {
        money_format: "&#8361;{{amount_no_decimals}}",
        money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
      };
      break;
    case "LKR":
      return {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} LKR",
      };
      break;
    case "SEK":
      return {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr SEK",
      };
      break;
    case "CHF":
      return {
        money_format: "SFr. {{amount}}",
        money_with_currency_format: "SFr. {{amount}} CHF",
      };
      break;
    case "TWD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TWD",
      };
      break;
    case "THB":
      return {
        money_format: "{{amount}} &#xe3f;",
        money_with_currency_format: "{{amount}} &#xe3f; THB",
      };
      break;
    case "TZS":
      return {
        money_format: "{{amount}} TZS",
        money_with_currency_format: "{{amount}} TZS",
      };
      break;
    case "TTD":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TTD",
      };
      break;
    case "TND":
      return {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} DT",
      };
      break;
    case "TRY":
      return {
        money_format: "{{amount}}TL",
        money_with_currency_format: "{{amount}}TL",
      };
      break;
    case "UGX":
      return {
        money_format: "Ush {{amount_no_decimals}}",
        money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
      };
      break;
    case "UAH":
      return {
        money_format: "₴{{amount}}",
        money_with_currency_format: "₴{{amount}} UAH",
      };
      break;
    case "AED":
      return {
        money_format: "Dhs. {{amount}}",
        money_with_currency_format: "Dhs. {{amount}} AED",
      };
      break;
    case "UYU":
      return {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} UYU",
      };
      break;
    case "VUV":
      return {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}}VT",
      };
      break;
    case "VEF":
      return {
        money_format: "Bs. {{amount_with_comma_separator}}",
        money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
      };
      break;
    case "VND":
      return {
        money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} VND",
      };
      break;
    case "XBT":
      return {
        money_format: "{{amount_no_decimals}} BTC",
        money_with_currency_format: "{{amount_no_decimals}} BTC",
      };
      break;
    case "XOF":
      return {
        money_format: "CFA{{amount}}",
        money_with_currency_format: "CFA{{amount}} XOF",
      };
      break;
    case "ZMW":
      return {
        money_format: "K{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "ZMW{{amount_no_decimals_with_comma_separator}}",
      };
  }
}

function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};


function buildDialogBlock() {
    return "<div style='display:none;'><div id='dialog' title='Basic dialog'><p>Your product isn't ready to go live. <br/>Delete all variants from the product and click save. <br/> </br/> Click <a target='_blank' href='https://apippa.freshdesk.com/support/solutions/articles/67000321459-add-to-cart-not-working'>here</a> to learn more.</p></div></div>";
}

function buildErrorBlock() {
    return "<div id='alert-block' class='hide-element alert float-left mt-4 w-100 clearfix alert-danger'>Please upload an image</div>";
}

function generateStep(size) {
    var num = 1
    var s = num + "";
    while (s.length < size) s = "0" + s;
    if (size > 0) {
        s = "0." + s;
    }
    return parseFloat(s)
}

function showDialog() {
    jQuery("#dialog").dialog({
        draggable: false,
        resizable: false,
        title: 'Custom Price Calculator Alert!',
        width: 430,
        height: 230
    });
}

function globalHelper_Escape(input) {
    input = input.replace(/\"/g, "\\\"");
    return input;
}

function globalHelper_ReportError(err, msg1 = '') {
    var errMsg = JSON.stringify(err, Object.getOwnPropertyNames(err));
    errMsg = errMsg + ', Msg1 = ' + msg1;
    jQuery.ajax({
        method: "POST",
        url: baseCalculatorApiUrl + "/api/analytics/errors",
        data: JSON.stringify({ calculatorId: cpc_calculatorId, productId: cpc_productId, error: errMsg }),
        headers: { Accept: "application/json", "Content-Type": "application/json" }
    })
    .done(function () {
    });
}